import React from 'react';
import { Link } from 'react-router-dom';
import BuildDefault from '../Assets/build-default.webp';
import BuildGame from '../Assets/build-game.webp';
import BuildSomething from '../Assets/build-something.webp';
import ChatBubble from '../Assets/chat-bubble.webp';

const GrantsFunding = () => {
  const [hoveredId, setHoveredId] = React.useState('');

  const handleMouseEnter = (id) => {
    setHoveredId(id);
  };

  const handleMouseLeave = () => {
    setHoveredId('');
  };


  return (
    <main id="grants" className={hoveredId}>
      <div className="container px-4 mx-auto pt-10 md:pt-20  space-y-10 flex flex-col justify-between h-full overflow-hidden">
        <div className="flex flex-col justify-center items-center">
          <h1 data-text="Grants/Funding" className="zk-title text-[1.5rem] md:text-[2rem] font-russo uppercase mb-10 text-white text-shadow">Grants/Funding</h1>
          <h2 className="zk-container flex text-[1rem] md:text-[1.3rem]  font-bold text-center max-w-[800px] mx-auto">
            <div className="left-dot"></div>
            <div className="right-dot"></div>
            At ZKcandy, we're committed to building the next generation of Web3 games. If you have an idea you'd like to receive support, please fill the contact form below and we'll reach out to you
          </h2>
        </div>

        <div className="flex flex-row justify-center relative w-full max-w-[900px] mx-auto">
          <Link to="/contact" className={`absolute left-[-2%] transform -translate-y-1/2 bottom-[60%] z-10 transition delay-100 duration-200 ease-in-out ${hoveredId === 'build-something' ? 'opacity-0' : ''}  ${hoveredId === 'build-game' ? '' : 'animate-bounce'}`} onMouseEnter={() => handleMouseEnter('build-game')} onMouseLeave={() => handleMouseLeave()}>
            <img className="-scale-x-100 absolute transform -translate-y-1/2 top-1/2" src={ChatBubble} alt="Chat Bubble" />
            <h3 id="build-game" className="leading-none text-[1rem] md:text-[2rem] relative px-4 md:px-10 font-bold text-[#1d1d1b] font-indie-flower text-center">I want to build <br /> a game</h3>
          </Link>

          <div className="flex items-end relative h-[]">
            <img className="w-full" src={BuildDefault} alt="Build Default" />
            <img className={`w-full absolute bottom-0 transition delay-100 duration-200 ease-in-out ${hoveredId === 'build-game' ? '' : 'opacity-0'}`} src={BuildGame} alt="Build Game" />
            <img className={`w-full absolute bottom-0 transition delay-100 duration-200 ease-in-out ${hoveredId === 'build-something' ? '' : 'opacity-0'}`} src={BuildSomething} alt="Build Somethingelse" />
          </div>

          <Link to="/contact" className={`absolute right-[-2%] transform -translate-y-1/2 bottom-[70%] z-10 transition delay-100 duration-200 ease-in-out ${hoveredId === 'build-game' ? 'opacity-0' : ''}   ${hoveredId === 'build-something' ? '' : 'animate-bounce'}`} onMouseEnter={() => handleMouseEnter('build-something')} onMouseLeave={() => handleMouseLeave()}>
            <img className="absolute transform -translate-y-1/2 top-1/2" src={ChatBubble} alt="Chat Bubble" />
            <h3 id="build-something" className="leading-none text-[1rem] md:text-[2rem] relative px-4 md:px-10 font-bold text-center text-[#1d1d1b] font-indie-flower ">I want to build <br /> something else</h3>
          </Link>
        </div>
      </div>
    </main>
  );
};

export default GrantsFunding;